import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'

export const MULTI_STEP_FORM = `
...on multiStepForm_Entry {
  id
  typeHandle

  blockId

  ${ IMAGE_DESKTOP }
  ${ IMAGE_MOBILE }
  
  heading {
    html
  }
  bottomText
  
  formSettings {
    ... on formSettings_ContentBlock {
      heading
      formId
      redirectLocation {
        url
      }
      onlyBusinessEmail
      errorValidateBusinessEmail
    }
  }
}
`